import { useInfiniteQuery } from "react-query";
import { authInstance } from "apis";

interface Params {
  keyword?: string;
  categoryIds?: number[];
  origin?: string;
  // resistPrinting?: string;
  locationId?: number;
  purposeId?: number;
  minPrice?: number;
  maxPrice?: number;
  item?: string;
  range?: string;
  page?: number;
}

interface Props {
  params: Params;
  options?: {
    onSuccess: () => void;
  };
  enabled?: boolean;
}

const useProducts = ({ params, options, enabled }: Props) => {
  const fetcher = async (page: number) => {
    const { data } = await authInstance.get("product", {
      params: {
        ...params,
        page,
      },
    });
    return data;
  };

  const { data, isError, fetchNextPage, hasNextPage } = useInfiniteQuery(
    ["product", params, enabled],
    ({ pageParam = 1 }) => fetcher(pageParam),
    {
      onSuccess: () => {
        options?.onSuccess();
      },
      enabled,
      getNextPageParam: ({ next }) => next,
      select: (data) => ({
        pages: data.pages.flatMap((page) => page.products),
        pageParams: data.pageParams,
      }),
    }
  );

  return { products: data?.pages, isError, fetchNextPage, hasNextPage };
};

export default useProducts;
